export const UPDATE_IS_REVIEW_SUBMITTED = "UPDATE_IS_REVIEW_SUBMITTED";

export const UPDATE_IS_USER_SUBMITTING = "UPDATE_IS_USER_SUBMITTING";

export const UPDATE_REVIEW_FORM_DRAFT_STATUS =
  "UPDATE_REVIEW_FORM_DRAFT_STATUS";

export const UPDATE_IS_VALIDATION_ERROR = "UPDATE_IS_VALIDATION_ERROR";

export const UPDATE_SECTION_LIST = "UPDATE_SECTION_LIST";

export const UPDATE_SECTION_DATA = "UPDATE_SECTION_DATA";

export const UPDATE_CALCULATED_SCORE = "UPDATE_CALCULATED_SCORE";
export const UPDATE_MANDATORY_COUNT = "UPDATE_MANDATORY_COUNT";
export const UPDATE_MANDATORY_ANSWERED = "UPDATE_MANDATORY_ANSWERED";

export const UPDATE_REVIEW_TO_INFO = "UPDATE_REVIEW_TO_INFO";

export const UPDATE_REVIEW_TO_ID = "UPDATE_REVIEW_TO_ID";

export const UPDATE_REVIEW_WRITER_INFO = "UPDATE_REVIEW_WRITER_INFO";
export const UPDATE_REVIEW_TABS_DATA = "UPDATE_REVIEW_TABS_DATA";
export const UPDATE_SELECTED_REVIEW_TAB = "UPDATE_SELECTED_REVIEW_TAB";

export const UPDATE_IS_FETCHING_REVIEW_FORM_TABS =
  "UPDATE_IS_FETCHING_REVIEW_FORM_TABS";

export const UPDATE_IS_FETCHING_REVIEW_FORM = "UPDATE_IS_FETCHING_REVIEW_FORM";

export const UPDATE_IS_FORM_CONTAINS_TABULAR_VIEW =
  "UPDATE_IS_FORM_CONTAINS_TABULAR_VIEW";

export const RESET_REVIEW_FORM = "RESET_REVIEW_FORM";

export const BATCH_UPDATE_TABLE_CELLS = "BATCH_UPDATE_TABLE_CELLS";

export const batchUpdateTableCells = (payload) => ({
  type: BATCH_UPDATE_TABLE_CELLS,
  payload: {
    blockId: payload.blockId,
    updates: payload.updates, // Array of { rowId, columnKey, reviewerId, value }
  },
});
